import * as React from "react";
import PropTypes from "prop-types";
import { Box, Card, Container, CssBaseline, Link, Typography } from "@mui/material";
import AppTheme from "../shared-theme/AppTheme";

export default function LegalDocumentPage({ title, lastUpdated, children }) {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Box sx={{ minHeight: "100dvh", bgcolor: "#f7f8fa", py: { xs: 3, md: 6 } }}>
        <Container maxWidth="md">
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <Link href="/signin" aria-label="Go to SEEDS sign in">
              <Box
                component="img"
                src="/images/seedsLogo.png"
                alt="SEEDS"
                sx={{ width: 88, height: 88, objectFit: "contain" }}
              />
            </Link>
          </Box>

          <Card
            variant="outlined"
            component="main"
            sx={{
              p: { xs: 2.5, sm: 4, md: 5 },
              borderColor: "#e2e5e9",
              borderRadius: 3,
              boxShadow: "0 12px 34px rgba(15, 23, 42, 0.06)",
            }}
          >
            <Typography component="h1" variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
              {title}
            </Typography>
            <Typography color="text.secondary" sx={{ fontWeight: 600, mb: 4 }}>
              Last updated: {lastUpdated}
            </Typography>

            <Box
              sx={{
                color: "text.primary",
                "& p": { fontSize: 16, lineHeight: 1.8, mb: 2.25 },
                "& p:last-of-type": { mb: 0 },
                "& strong": { fontWeight: 800 },
              }}
            >
              {children}
            </Box>
          </Card>

          <Typography color="text.secondary" sx={{ textAlign: "center", fontSize: 13, mt: 3 }}>
            © 2026 SEEDS PLATFORM
          </Typography>
        </Container>
      </Box>
    </AppTheme>
  );
}

LegalDocumentPage.propTypes = {
  title: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
